import _sfc_main from './WatchlistList.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-widget fds-watchlist-list", class: { "fds-ui-loading": _setup.isLoadingStoreData } }, [_vm._t("root", function() {
    return [_vm._t("header", function() {
      return [_c("div", { staticClass: "fds-watchlist-list__header" }, [_vm._t("header:title", null, null, { storeModule: _setup.storeModule, localizationSupport: _setup.localizationSupport }), _vm._t("header:button(create)", function() {
        return [_c("button", { ref: "watchlistCreateToggleButton", staticClass: "fds-ui-button fds-ui-button--secondary", attrs: { "type": "button", "aria-haspopup": "dialog", "disabled": _setup.isLoadingStoreData }, on: { "click": _setup.openCreateModal } }, [_vm._v(" " + _vm._s(_setup.translate("watchlistList.createWatchlistAction")) + " ")])];
      }, null, { storeModule: _setup.storeModule, localizationSupport: _setup.localizationSupport, openCreateModal: _setup.openCreateModal, label: "watchlistList.createWatchlistAction" })], 2)];
    }, null, { storeModule: _setup.storeModule, localizationSupport: _setup.localizationSupport, openCreateModal: _setup.openCreateModal }), _setup.showNoWatchlistsAlert ? [_vm._t("info", function() {
      return [_c("div", { staticClass: "fds-ui-alert fds-ui-alert--info" }, [_c("span", { staticClass: "fds-ui-alert__heading" }, [_vm._v(_vm._s(_setup.translate("watchlistList.noWatchlist.title")))]), _c("div", { staticClass: "fds-ui-alert__body" }, [_vm._v(" " + _vm._s(_setup.translate("watchlistList.noWatchlist.message")) + " ")])])];
    }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, label: "watchlistList.noWatchlist.title" })] : _vm._e(), _vm._t("table", function() {
      return [!_setup.storeData || _setup.storeData?.length > 0 || _setup.isLoadingStoreData ? _c("table", { staticClass: "fds-table fds-watchlist-list__table" }, [_vm._t("table:caption", function() {
        return [_c("caption", { staticClass: "fds-table__caption fds-sr-only" }, [_vm._v(" " + _vm._s(_setup.translate("watchlistList.caption")) + " ")])];
      }, null, { storeModule: _setup.storeModule, localizationSupport: _setup.localizationSupport, label: "watchlistList.caption" }), _vm._t("table:header", function() {
        return [_c("thead", { staticClass: "fds-table__header fds-watchlist-list__table__header" }, [_c("tr", [_vm._l(_setup.headers, function(header, index) {
          return [_vm._t(`table:header:cell(${header.key})`, function() {
            return [_c("th", { key: `fds-watchlist-list-header-${index}`, attrs: { "scope": "col" } }, [_vm._t(`table:header:cell(${header.key}):content`, function() {
              return [_vm._v(" " + _vm._s(_setup.translate(header.label)) + " ")];
            }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, headers: _setup.headers, header })], 2)];
          }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, headers: _setup.headers, header })];
        }), _vm._t("table:header:cell(actions)", function() {
          return [_c("th", { attrs: { "scope": "col" } }, [_vm._t("table:header:cell(actions):content", function() {
            return [_c("div", { staticClass: "fds-table__header-item" }, [_vm._v(" " + _vm._s(_setup.translate("watchlistList.actions")) + " ")])];
          }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, headers: _setup.headers, header: { key: "actions", label: "watchlistList.actions" } })], 2)];
        }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, headers: _setup.headers, header: { key: "actions", label: "watchlistList.actions" } })], 2)])];
      }, null, { headers: _setup.headers, storeModule: _setup.storeModule, localizationSupport: _setup.localizationSupport }), _vm._t("table:body", function() {
        return [_c("tbody", { staticClass: "fds-table__body fds-watchlist-list__table__body" }, [_vm._l(_setup.storeData, function(item, index) {
          return [_vm._t(`table:body:row`, function() {
            return [_c("tr", _vm._g(_vm._b({ key: `row-${index}` }, "tr", _setup.tableRowAttributes, false), _setup.hasTableRowClickListener ? _setup.tableRowEvents(item) : void 0), [_vm._t(`table:body:row:cell(${_setup.headers[0].key})`, function() {
              return [_c("td", [_vm._t(`table:body:row:cell(${_setup.headers[0].key}):content`, function() {
                return [_c(_setup.HoistComponent, [_c(_setup.UiName, _vm._g({ attrs: { "name": _setup.textFormat(item.name) } }, _setup.hasTableRowKeyClickListener ? { click: () => _setup.onTableRowKeyClick(item) } : {}))], 1)];
              }, null, { item, index, localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, tableRow: _setup.tableRow })], 2)];
            }, null, { item, index, localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, tableRow: _setup.tableRow }), _vm._t(`table:body:row:cell(${_setup.headers[1].key})`, function() {
              return [_c("td", [_vm._t(`table:body:row:cell(${_setup.headers[1].key}):content`, function() {
                return [_vm._v(" " + _vm._s(_setup.numberFormat(item.numberOfPositions, { type: "integer" })) + " ")];
              }, null, { item, index, localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, tableRow: _setup.tableRow })], 2)];
            }, null, { item, index, localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, tableRow: _setup.tableRow }), _vm._t("table:body:row:cell(actions)", function() {
              return [_c("td", [_vm._t("table:body:row:cell(actions):content", function() {
                return [_c(_setup.HoistComponent, [_c(_setup.UiDropdownMenu, { attrs: { "locale": _vm.locale, "button-text": _setup.translate("watchlistList.showActions") }, scopedSlots: _vm._u([{ key: "dialog:content", fn: function() {
                  return [_c("li", { staticClass: "fds-ui-dropdown-menu__dialog-item" }, [_vm._t("table:body:row:cell(actions):content:button(edit)", function() {
                    return [_c("button", { staticClass: "fds-ui-button fds-ui-button--icon fds-watchlist__controls__button", attrs: { "type": "button", "aria-haspopup": "dialog" }, on: { "click": function($event) {
                      return _setup.openEditModal(item.id);
                    } } }, [_vm._t("table:body:row:cell(actions):content:button(edit):content", function() {
                      return [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--edit" }), _vm._v(" " + _vm._s(_setup.translate("watchlistList.editWatchlistAction")) + " ")];
                    }, null, {
                      item,
                      index,
                      watchlistId: _setup.watchlistId,
                      editModalToggle: _setup.editModalToggle,
                      openEditModal: _setup.openEditModal,
                      closeEditModal: _setup.closeEditModal,
                      onWatchlistEdit: _setup.onWatchlistEdit,
                      localizationSupport: _setup.localizationSupport,
                      label: "watchlistList.editWatchlistAction"
                    })], 2)];
                  }, null, {
                    item,
                    index,
                    watchlistId: _setup.watchlistId,
                    editModalToggle: _setup.editModalToggle,
                    openEditModal: _setup.openEditModal,
                    closeEditModal: _setup.closeEditModal,
                    onWatchlistEdit: _setup.onWatchlistEdit,
                    localizationSupport: _setup.localizationSupport,
                    label: "watchlistList.editWatchlistAction"
                  })], 2), _c("li", { staticClass: "fds-ui-dropdown-menu__dialog-item" }, [_vm._t("table:body:row:cell(actions):content:button(delete)", function() {
                    return [_c("button", { staticClass: "fds-ui-button fds-ui-button--icon fds-watchlist__controls__button", attrs: { "type": "button", "aria-haspopup": "dialog" }, on: { "click": function($event) {
                      return _setup.openDeleteModal(item.id);
                    } } }, [_vm._t("table:body:row:cell(actions):content:button(delete):content", function() {
                      return [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--remove" }), _vm._v(" " + _vm._s(_setup.translate("watchlistList.deleteWatchlistAction")) + " ")];
                    }, null, {
                      item,
                      index,
                      watchlistId: _setup.watchlistId,
                      deleteModalToggle: _setup.deleteModalToggle,
                      openDeleteModal: _setup.openDeleteModal,
                      closeDeleteModal: _setup.closeDeleteModal,
                      onWatchlistDelete: _setup.onWatchlistDelete,
                      localizationSupport: _setup.localizationSupport,
                      label: "watchlistList.deleteWatchlistAction"
                    })], 2)];
                  }, null, {
                    item,
                    index,
                    watchlistId: _setup.watchlistId,
                    deleteModalToggle: _setup.deleteModalToggle,
                    openDeleteModal: _setup.openDeleteModal,
                    closeDeleteModal: _setup.closeDeleteModal,
                    onWatchlistDelete: _setup.onWatchlistDelete,
                    localizationSupport: _setup.localizationSupport,
                    label: "watchlistList.deleteWatchlistAction"
                  })], 2)];
                }, proxy: true }], null, true) })], 1)];
              }, null, {
                item,
                index,
                storeModule: _setup.storeModule,
                localizationSupport: _setup.localizationSupport,
                watchlistId: _setup.watchlistId,
                createModalToggle: _setup.createModalToggle,
                editModalToggle: _setup.editModalToggle,
                deleteModalToggle: _setup.deleteModalToggle,
                openCreateModal: _setup.openCreateModal,
                closeCreateModal: _setup.closeCreateModal,
                onWatchlistCreate: _setup.onWatchlistCreate,
                openEditModal: _setup.openEditModal,
                closeEditModal: _setup.closeEditModal,
                onWatchlistEdit: _setup.onWatchlistEdit,
                openDeleteModal: _setup.openDeleteModal,
                closeDeleteModal: _setup.closeDeleteModal,
                onWatchlistDelete: _setup.onWatchlistDelete
              })], 2)];
            }, null, {
              item,
              index,
              storeModule: _setup.storeModule,
              localizationSupport: _setup.localizationSupport,
              watchlistId: _setup.watchlistId,
              createModalToggle: _setup.createModalToggle,
              editModalToggle: _setup.editModalToggle,
              deleteModalToggle: _setup.deleteModalToggle,
              openCreateModal: _setup.openCreateModal,
              closeCreateModal: _setup.closeCreateModal,
              onWatchlistCreate: _setup.onWatchlistCreate,
              openEditModal: _setup.openEditModal,
              closeEditModal: _setup.closeEditModal,
              onWatchlistEdit: _setup.onWatchlistEdit,
              openDeleteModal: _setup.openDeleteModal,
              closeDeleteModal: _setup.closeDeleteModal,
              onWatchlistDelete: _setup.onWatchlistDelete
            })], 2)];
          }, null, {
            item,
            index,
            storeModule: _setup.storeModule,
            localizationSupport: _setup.localizationSupport,
            tableRow: _setup.tableRow,
            watchlistId: _setup.watchlistId,
            createModalToggle: _setup.createModalToggle,
            editModalToggle: _setup.editModalToggle,
            deleteModalToggle: _setup.deleteModalToggle,
            openCreateModal: _setup.openCreateModal,
            closeCreateModal: _setup.closeCreateModal,
            onWatchlistCreate: _setup.onWatchlistCreate,
            openEditModal: _setup.openEditModal,
            closeEditModal: _setup.closeEditModal,
            onWatchlistEdit: _setup.onWatchlistEdit,
            openDeleteModal: _setup.openDeleteModal,
            closeDeleteModal: _setup.closeDeleteModal,
            onWatchlistDelete: _setup.onWatchlistDelete
          })];
        })], 2)];
      }, null, {
        headers: _setup.headers,
        storeModule: _setup.storeModule,
        localizationSupport: _setup.localizationSupport,
        tableRow: _setup.tableRow,
        watchlistId: _setup.watchlistId,
        createModalToggle: _setup.createModalToggle,
        editModalToggle: _setup.editModalToggle,
        deleteModalToggle: _setup.deleteModalToggle,
        openCreateModal: _setup.openCreateModal,
        closeCreateModal: _setup.closeCreateModal,
        onWatchlistCreate: _setup.onWatchlistCreate,
        openEditModal: _setup.openEditModal,
        closeEditModal: _setup.closeEditModal,
        onWatchlistEdit: _setup.onWatchlistEdit,
        openDeleteModal: _setup.openDeleteModal,
        closeDeleteModal: _setup.closeDeleteModal,
        onWatchlistDelete: _setup.onWatchlistDelete
      })], 2) : _vm._e()];
    }, null, {
      headers: _setup.headers,
      storeModule: _setup.storeModule,
      localizationSupport: _setup.localizationSupport,
      tableRow: _setup.tableRow,
      watchlistId: _setup.watchlistId,
      createModalToggle: _setup.createModalToggle,
      editModalToggle: _setup.editModalToggle,
      deleteModalToggle: _setup.deleteModalToggle,
      openCreateModal: _setup.openCreateModal,
      closeCreateModal: _setup.closeCreateModal,
      onWatchlistCreate: _setup.onWatchlistCreate,
      openEditModal: _setup.openEditModal,
      closeEditModal: _setup.closeEditModal,
      onWatchlistEdit: _setup.onWatchlistEdit,
      openDeleteModal: _setup.openDeleteModal,
      closeDeleteModal: _setup.closeDeleteModal,
      onWatchlistDelete: _setup.onWatchlistDelete
    }), _vm._t("modal(create)", function() {
      return [_c(_setup.UiModal, { staticClass: "fds-watchlist-list__create-modal", attrs: { "value": _setup.createModalToggle }, on: { "input": _setup.closeCreateModal }, scopedSlots: _vm._u([{ key: "header", fn: function() {
        return [_c(_setup.UiRenderNothing)];
      }, proxy: true }, { key: "body", fn: function() {
        return [_c(_setup.HoistComponent, [_c(_setup.WatchlistCreate, { attrs: { "locale": _setup.props.locale }, on: { "submit": _setup.onWatchlistCreate, "cancel": _setup.closeCreateModal }, scopedSlots: _vm._u([{ key: "header:actions", fn: function() {
          return [_c("button", { staticClass: "fds-watchlist-list__close-btn", attrs: { "type": "button", "aria-label": "close" }, on: { "click": _setup.closeCreateModal } }, [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--close" })])];
        }, proxy: true }]) })], 1)];
      }, proxy: true }, { key: "footer", fn: function() {
        return [_c(_setup.UiRenderNothing)];
      }, proxy: true }]) })];
    }, null, {
      watchlistId: _setup.watchlistId,
      createModalToggle: _setup.createModalToggle,
      editModalToggle: _setup.editModalToggle,
      deleteModalToggle: _setup.deleteModalToggle,
      openCreateModal: _setup.openCreateModal,
      closeCreateModal: _setup.closeCreateModal,
      onWatchlistCreate: _setup.onWatchlistCreate,
      openEditModal: _setup.openEditModal,
      closeEditModal: _setup.closeEditModal,
      onWatchlistEdit: _setup.onWatchlistEdit,
      openDeleteModal: _setup.openDeleteModal,
      closeDeleteModal: _setup.closeDeleteModal,
      onWatchlistDelete: _setup.onWatchlistDelete
    }), _vm._t("modal(edit)", function() {
      return [_c(_setup.UiModal, { staticClass: "fds-watchlist-list__edit-modal", attrs: { "value": _setup.editModalToggle }, on: { "input": _setup.closeEditModal }, scopedSlots: _vm._u([{ key: "header", fn: function() {
        return [_c(_setup.UiRenderNothing)];
      }, proxy: true }, { key: "body", fn: function() {
        return [_c(_setup.HoistComponent, [_c(_setup.WatchlistEdit, { attrs: { "id": _setup.watchlistId, "locale": _setup.props.locale }, on: { "edit": _setup.onWatchlistEdit, "cancel": _setup.closeEditModal }, scopedSlots: _vm._u([{ key: "header:actions", fn: function() {
          return [_c("button", { staticClass: "fds-watchlist-list__close-btn", attrs: { "type": "button", "aria-label": "close" }, on: { "click": _setup.closeEditModal } }, [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--close" })])];
        }, proxy: true }]) })], 1)];
      }, proxy: true }, { key: "footer", fn: function() {
        return [_c(_setup.UiRenderNothing)];
      }, proxy: true }]) })];
    }, null, {
      watchlistId: _setup.watchlistId,
      createModalToggle: _setup.createModalToggle,
      editModalToggle: _setup.editModalToggle,
      deleteModalToggle: _setup.deleteModalToggle,
      openCreateModal: _setup.openCreateModal,
      closeCreateModal: _setup.closeCreateModal,
      onWatchlistCreate: _setup.onWatchlistCreate,
      openEditModal: _setup.openEditModal,
      closeEditModal: _setup.closeEditModal,
      onWatchlistEdit: _setup.onWatchlistEdit,
      openDeleteModal: _setup.openDeleteModal,
      closeDeleteModal: _setup.closeDeleteModal,
      onWatchlistDelete: _setup.onWatchlistDelete
    }), _vm._t("modal(delete)", function() {
      return [_c(_setup.UiModal, { staticClass: "fds-watchlist-list__delete-modal", attrs: { "value": _setup.deleteModalToggle }, on: { "input": _setup.closeDeleteModal }, scopedSlots: _vm._u([{ key: "header", fn: function() {
        return [_c(_setup.UiRenderNothing)];
      }, proxy: true }, { key: "body", fn: function() {
        return [_c(_setup.HoistComponent, [_c(_setup.WatchlistDelete, { attrs: { "id": _setup.watchlistId, "locale": _setup.props.locale }, on: { "delete": _setup.onWatchlistDelete, "cancel": _setup.closeDeleteModal }, scopedSlots: _vm._u([{ key: "header:actions", fn: function() {
          return [_c("button", { staticClass: "fds-watchlist-list__close-btn", attrs: { "type": "button", "aria-label": "close" }, on: { "click": _setup.closeDeleteModal } }, [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--close" })])];
        }, proxy: true }]) })], 1)];
      }, proxy: true }, { key: "footer", fn: function() {
        return [_c(_setup.UiRenderNothing)];
      }, proxy: true }]) })];
    }, null, {
      watchlistId: _setup.watchlistId,
      createModalToggle: _setup.createModalToggle,
      editModalToggle: _setup.editModalToggle,
      deleteModalToggle: _setup.deleteModalToggle,
      openCreateModal: _setup.openCreateModal,
      closeCreateModal: _setup.closeCreateModal,
      onWatchlistCreate: _setup.onWatchlistCreate,
      openEditModal: _setup.openEditModal,
      closeEditModal: _setup.closeEditModal,
      onWatchlistEdit: _setup.onWatchlistEdit,
      openDeleteModal: _setup.openDeleteModal,
      closeDeleteModal: _setup.closeDeleteModal,
      onWatchlistDelete: _setup.onWatchlistDelete
    })];
  }, null, {
    headers: _setup.headers,
    storeModule: _setup.storeModule,
    localizationSupport: _setup.localizationSupport,
    pagination: _setup.pagination,
    watchlistId: _setup.watchlistId,
    createModalToggle: _setup.createModalToggle,
    editModalToggle: _setup.editModalToggle,
    deleteModalToggle: _setup.deleteModalToggle,
    openCreateModal: _setup.openCreateModal,
    closeCreateModal: _setup.closeCreateModal,
    onWatchlistCreate: _setup.onWatchlistCreate,
    openEditModal: _setup.openEditModal,
    closeEditModal: _setup.closeEditModal,
    onWatchlistEdit: _setup.onWatchlistEdit,
    openDeleteModal: _setup.openDeleteModal,
    closeDeleteModal: _setup.closeDeleteModal,
    onWatchlistDelete: _setup.onWatchlistDelete
  }), _vm._t("pagination", function() {
    return [_c(_setup.HoistComponent, [_setup.totalPages > 1 ? _c(_setup.UiPagination, { attrs: { "locale": _vm.locale, "value": _setup.activePageOffset, "total-pages": _setup.totalPages }, on: { "input": _setup.onClickPagination } }) : _vm._e()], 1)];
  }, null, { storeModule: _setup.storeModule, localizationSupport: _setup.localizationSupport, pagination: _setup.pagination })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/watchlist-list/WatchlistList.vue";
var WatchlistList = __component__.exports;

export { WatchlistList as default };
